import _ from 'underscore';
import React, { useContext } from 'react';
import { InstrumentationServiceContext } from '@bingads-webui-campaign-react/smart-page-context';
import { DefaultErrorView } from './default-error-view';

function createErrorMessage(error, { componentStack = '' }) {
  if (_.isString(error)) {
    return `${error} ${componentStack}`;
  }
  if (_.isObject(error)) {
    const errorStack = error.stack ? error.stack : '';
    return `${error.message} ${componentStack} ${errorStack}`.trim();
  }
  // If some other object, log it as is
  try {
    return error.toString();
  } catch (e) {
    return 'Error could not be serialized';
  }
}

const getErrorView = errorViewMode => () => <DefaultErrorView errorViewMode={errorViewMode} />;

export const getErrorOptions = ({ logger, errorViewMode }) => {
  if (!logger) {
    return {
      logError: _.loop,
      renderErrorView: getErrorView(errorViewMode),
    };
  }
  return ({
    logError: ({ error, info }) => {
      logger.logError(createErrorMessage(error, info));
    },
    renderErrorView: getErrorView(errorViewMode),
  });
};

export const withErrorOptions = (Component, errorViewMode) => {
  const Wrapper = React.memo((props) => {
    const logger = useContext(InstrumentationServiceContext);

    return (
      <Component
        errorOptions={getErrorOptions({ logger, errorViewMode })}
        {...props}
      />
    );
  });

  return Wrapper;
};
